import { motiveChain } from "@/mocks/home";

export default function MotiveChain() {
  return (
    <section id="chain" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-site px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <i className="ri-links-line text-sm"></i>
              MOTIVE CHAIN
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              动机链条
            </h2>
          </div>
          <p className="max-w-md text-sm leading-7 text-foreground-600">
            一个热点从出现到沉寂，通常会走过五个阶段。看懂每一环的动机，比记住结论更重要。
          </p>
        </div>

        <div className="relative mt-12">
          <div className="absolute left-[19px] top-0 h-full w-px bg-background-300 lg:left-0 lg:top-[19px] lg:h-px lg:w-full"></div>

          <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-6">
            {motiveChain.map((step, i) => (
              <div key={step.no} className="relative flex gap-4 lg:flex-col lg:gap-0">
                <span
                  className={`relative z-10 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full font-heading text-sm font-bold ${
                    i === 2
                      ? "bg-accent-500 text-background-50"
                      : "border border-background-300 bg-background-50 text-foreground-800"
                  }`}
                >
                  {step.no}
                </span>
                <div className="lg:mt-5 lg:pr-4">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {step.title}
                    </h3>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                      {step.keyword}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-7 text-foreground-600">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}